import { useState, useEffect } from 'react';

interface HeaderProps {
  isScrolled: boolean;
}

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };

  const whatsappNumber = '+96871989006';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/badfdf0c5f2d8472e707f25057dbcc7e/148c624465aa7169570d00c7724295b9.png" 
              alt="Cleaning Bees Logo" 
              className="h-24 w-auto"
            />
          </div>

          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-yellow-500 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-yellow-500 font-medium transition-colors whitespace-nowrap cursor-pointer">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-yellow-500 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Services
            </button>
            <button onClick={() => scrollToSection('why-choose-us')} className="text-gray-700 hover:text-yellow-500 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Why Choose Us
            </button>
            <button onClick={() => scrollToSection('areas')} className="text-gray-700 hover:text-yellow-500 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Areas
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-yellow-500 font-medium transition-colors whitespace-nowrap cursor-pointer">
              Contact
            </button>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href={`tel:${whatsappNumber}`}
              className="flex items-center space-x-2 text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span className="font-medium whitespace-nowrap">+968 71 989 006</span>
            </a>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 bg-yellow-500 text-black px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span className="font-medium">WhatsApp</span>
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-yellow-500 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-gray-700 hover:text-yellow-500 font-medium py-2 cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-yellow-500 font-medium py-2 cursor-pointer">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-700 hover:text-yellow-500 font-medium py-2 cursor-pointer">
              Services
            </button>
            <button onClick={() => scrollToSection('why-choose-us')} className="block w-full text-left text-gray-700 hover:text-yellow-500 font-medium py-2 cursor-pointer">
              Why Choose Us
            </button>
            <button onClick={() => scrollToSection('areas')} className="block w-full text-left text-gray-700 hover:text-yellow-500 font-medium py-2 cursor-pointer">
              Areas
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-700 hover:text-yellow-500 font-medium py-2 cursor-pointer">
              Contact
            </button>
            <div className="pt-3 border-t border-gray-200 space-y-3">
              <a 
                href={`tel:${whatsappNumber}`}
                className="flex items-center space-x-2 text-gray-700 hover:text-yellow-500 cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span className="font-medium">+968 71 989 006</span>
              </a>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 bg-yellow-500 text-black px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span className="font-medium">WhatsApp</span>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}